const DEFAULT_OWNER = 'CSR';

function createEvent(
  type: string,
  date: string,
  idx: number,
  extra: {
    expiresInDays?: number;
    previousQuoteNumber?: string;
    previousQuoteID?: string;
    quoteId?: string;
    quoteNumber?: string;
    orderNumber?: string;
  }
) {
  return {
    owner: DEFAULT_OWNER,
    type,
    date,
    orderId: `order-${idx}`,
    documentNumber: `document-${idx}`,
    listId: `list-${idx}`,
    ...extra
  };
}

export const DUMMY_CSR_EVENTS_DATA = [
  createEvent('PersonalInfoUpdated', '2016-12-30 14:47:12', 1, {}),
  createEvent('AddressBookUpdated', '2026-12-30 14:47:12', 2, {}),
  createEvent('AddressBookAdded', '2016-12-29 15:49:51', 3, {}),
  createEvent('AddressBookDeleted', '2016-07-29 05:49:52', 4, {}),
  createEvent('PaymentMethodUpdated', '2016-07-29 05:19:52', 5, {}),
  createEvent('AbandonedCart', '2016-07-29 05:49:02', 6, {}),
  createEvent('ShoppingPreferencesUpdated', '2009-03-29 03:49:02', 7, {}),
  createEvent('MyEquipmentUpdated', '2022-10-29 15:47:53', 8, {}),
  createEvent('OrderCreated', '2016-08-29 19:39:53', 9, {}),
  createEvent('OrderQueued', '2019-12-29 15:29:30', 10, {}),
  createEvent('QuoteCreated', '2013-12-29 15:22:23', 11, {
    expiresInDays: 1,
    quoteNumber: 'AFQ00267BV',
    quoteId: '442270090'
  }),
  createEvent('QuoteCreated', '2017-04-29 15:23:55', 12, {
    expiresInDays: 0,
    quoteNumber: 'AFQ003667BV',
    quoteId: '442270089'
  }),
  createEvent('QuoteEdited', '2024-12-29 15:11:22', 13, {
    previousQuoteNumber: 'AFQ001666GEFE',
    previousQuoteID: '4422700165',
    quoteId: '442270092',
    quoteNumber: 'AFQ001667BV'
  }),
  createEvent('QuoteConverted', '2088-12-29 15:55:55', 14, {
    quoteNumber: '3BQ05060RF8',
    orderNumber: 'ORD002349PS'
  }),
  createEvent('QuoteDeleted', '2003-12-29 15:47:17', 15, {
    quoteNumber: '00Q0035690'
  })
];
